<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 2.goodsTitle-container-start -->
    <!-- <goods-title></goods-title> -->
    <tabbar :tabbarIndex="0"></tabbar>
    <!-- <img width="100%" src="../../images/head.png"> -->
    <img
      width="100%"
      :src="web_top_imgurl"
      @click="link(web_top_linkurl)"
      alt=""
    />
    <marquee behavior="scroll" class="tishi">{{ web_rolling_notice }}</marquee>
    <div class="person">
        <div class="kefu"
          @click="clicked_OnlineService()"
          style="cursor: pointer;">
        <img
          style="margin-top: 30px; text-align: center"
          src="../../images/kefu.png"
        />
        <div
          style="
            height: 30px;
            line-height: 30px;
            background-color: rgb(204, 127, 12);
            color: #fff;
            margin-top: 10px;
          "
        >
          在线客服
        </div>
        <div
          style="
            height: 30px;
            line-height: 30px;
            background-color: rgb(204, 127, 12);
            color: #fff;
            margin-top: 10px;
          "
        >
          售后处理
        </div>
      </div>
    </div>
    <!-- 2.goodsTitle-container-end -->

    <!-- 3.goodsMain-container-start -->
    <div class="goodsMain">
      <div class="show borderShadow">
        <!-- <el-button type="text" @click="dialogVisible = true" >点击打开 Dialog</el-button> -->

        <el-dialog
          v-if="isdue != 1 && GGList.length > 0"
          :close-on-click-modal="close_modal"
          :visible.sync="dialogVisible"
          :modal="false"
          width="20%"
          :before-close="handleClose"
          :showClose="false"
          :center="true"
          style="margin-top: 140px;"
        >
          <div class="righttip">
            
            <div
              :class="index > 1 ? 'item hands' : 'item2 hands'"
              v-for="(item, index) of GGList"
              :key="index">
            <!-- <div class="tip"> {{ item.notice_title || "暂无标题" }}</div> -->
              <span>{{ index + 1 }}.</span>&nbsp;&nbsp;&nbsp;&nbsp;{{ item.notice_info || "暂无标题" }}
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false"
              ><span class="read">已阅读</span></el-button
            >
          </span>
        </el-dialog>
      </div>

      <div class="video" v-show="showNoice">
        <ul v-for="(item, index) in CCList" :key="index">
          <li v-show="item.show_type == 0">
            <div v-if="item.advert_url != '' && item.advert_url != '#'">
              <img
                class="listimg"
                :width="item.show_width"
                :src="item.advert_pic"
                @click="clickedNoceItem(item.advert_url)"
              />
            </div>
            <div v-else>
              <img
                class="listimg"
                :width="item.show_width"
                :src="item.advert_pic"
              />
            </div>
          </li>
          <li v-if="item.show_type == 1">
            <video
              controls
              :src="item.advert_pic"
              class="listimg" 
              :class="item.show_width"
            ></video>
            <!-- <video controls src="https://kaiyuan-back-file.oss-cn-beijing.aliyuncs.com/profile/upload/20220228/e8b414beda1046c5bd2fb9c8abceb7a9.mp4" class="listimg"></video> -->
          </li>
        </ul>
      </div>
      <div class="card borderShadow">
        <div class="left">
          <img v-if="cardInfo.img_pc" :src="cardInfo.img_pc" class="img" />
          <img v-else src="../../images/task1.png" class="img" />
        </div>
        <div class="middle">
          <div class="top">温馨提示:</div>
          <div class="middle oneLine" style="white-space: normal;">
            您好，{{
              cardInfo.card_type_show_name != null &&
              cardInfo.card_type_show_name.length > 0
                ? "您持有的是" + cardInfo.card_type_show_name + "，"
                : ""
            }}请选择以下您所喜欢的套餐类型，并进行兑换。
          </div>
          <div class="bottom twoLine">
            人工客服热线:
            <span v-for="(item, index) of web_tel" :key="index"
              >{{ item }} {{ index + 1 == web_tel.length ? "" : "、" }}</span
            >
          </div>
        </div>
        <!-- <div class="right borderShadow" v-if="isdue != 1 && GGList.length > 0">
          <div class="tip">公告</div>
          <div
            class="item hands"
            @click="watchGGDetail(item)"
            v-for="(item, index) of GGList"
            :key="index"
          >
            <span>{{ index + 1 }}.</span>{{ item.notice_title || "暂无标题" }}
          </div>
        </div> -->
        <div class="gq" v-if="isdue == 1">该卡为过期卡</div>
      </div>
      <div class="tip" v-if="isdue != 1">
        该卡为: 
        <span v-if="cardInfo.card_type==1">兑换卡</span>
        <span v-if="cardInfo.card_type==3">储值卡</span>
        <span v-if="cardInfo.card_type==4">多次卡</span>
        , 卡型是:
        {{ cardInfo.card_type_show_name}} ,{{ cardInfo.card_type==4?'当前卡还可兑换'+cardInfo.available_qty+'次':'' }}
      </div>
      <div class="tip" v-else>
        该卡为: 过期卡 {{ cardInfo.web_expire_index }}
      </div>
      <div class="goods borderShadow">
        <!-- <div @click="chooseGoods(item, index)" :class="item.is_deal==0?'item borderShadow':'item item-o borderShadow'" v-for="(item, index) of TCList" :key="index"> -->
        <div
          @click="chooseGoods(item, index)"
          :class="s_bshow(item)"
          v-for="(item, index) of TCList"
          :key="index"
        >
          <div class="top">
            <img v-if="item.pc_img" :src="item.pc_img" class="img" />
            <img v-else src="../../images/task1.png" class="img" />
          </div>
          <div class="middle oneLine">{{ item.setmeal_name || "暂无" }}</div>
          <div class="bottom oneLine">
            套餐编号:{{ item.setmeal_code || "暂无" }}
          </div>
          <div class="bottom oneLine" id="tishi" style="font-size: 12px;margin-top: 5px;" v-if="cardInfo.card_type==4">
            {{ item.available_qty>0&&item.is_deal==0?'该套餐还可兑换'+item.available_qty+'次':'不可兑换' }}
          </div>
        </div>
      </div>
      <!-- <div class="page" v-if="TCList.length > 5">
        <div class="total">
          共{{ totalPages ? totalPages : 1 }}页, 当前为第{{ pageNo }}页
        </div>
        <div class="up hands c-animation2" @click="upPage">上一页</div>
        <div class="down hands c-animation2" @click="downPage">下一页</div>
      </div> -->
    </div>
    <!-- 3.goodsMain-container-end -->

    <!-- 4.goodsFooter-container-start -->
    <c-footer></c-footer>
    <!-- <goods-footer></goods-footer> -->
    <!-- 4.goodsFooter-container-end -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
// import goodsTitle from "../../components/goodsTitle/goodsTitle";
import footer from "../../components/footer/footer";
// import goodsFooter from "../../components/goodsFooter/goodsFooter";
import {
  cardInterGGListRequest,
  cardInterTCRequest,
  cardInfoRequest,
  cardCustomizedInfoRequest,
  cardCustomizedAdvertListRequest,
} from "../../public/js/service";
var interval;

export default {
  data() {
    // 1.data
    return {
      showNoice: false, //控制大客户顶部广告显示隐藏
      web_rolling_notice: "", //滚动公告
      web_top_imgurl: "", // pc顶部图片链接
      web_top_linkurl: "", // pc顶部跳转链接
      close_modal: false,
      dialogVisible: true,
      currentPageInfo: {}, // 1.1.currentPageInfo
      card_type_id: "", // 1.2.卡型id
      token: "", // 1.3.token
      web_tel: "", // 1.4.客户电话
      cardInfo: {}, // 1.5.卡型信息
      sysId: "", // 1.6.sysId
      card_type: 1, // 1.7.卡类型，1普通卡3储值卡，只有1才能点击下面的套餐
      TCList: [], // 1.8.套餐列表
      GGList: [], // 1.9.套餐公告列表
      isdue: 0, // 1.10.当前卡是否过期了？1表示过期

      pageNo: 1, // 1.11.页码（第几页）
      pageSize: 10, // 1.12.页标（每页几条）
      totalPages: 1, // 1.13.总页码数
      lineClickTimer: null, // 1.14.防连点开关
      card_customized_id: "", // 1.15.绑定定制页id
      CCList: [], // 1.16.定制页广告列表
      xPos: 0,
      yPos: 0,
      xin: true,
      yin: true,
      step: 1,
      delay: 18,
      height: 0,
      Hoffset: 0,
      Woffset: 0,
      yon: 0,
      xon: 0,
      pause: true,
      thedivShow: true,
    };
  },

  components: {
    // 2.components
    // goodsTitle,
    // goodsFooter,
    cFooter: footer,
    tabbar,
  },

  methods: {
    clicked_OnlineService() {
      var url = localStorage.web_online_service;
      if (url && url != "" && url != "#") {
        url =
          url.toLowerCase().indexOf("http:") > -1 ||
          url.toLowerCase().indexOf("https:") > -1
            ? url
            : "http://" + url;
        var tempwindow = window.open("");
        tempwindow.location = url;
      }
    },
    changeStatus() {
      this.showNoice = !this.showNoice;
    },

    // 3.methods
    chooseGoods(item, index) {
      // 3.1.选择商品
      this.cTips = "第" + (index + 1) + "个套餐";

      if (item.is_deal == undefined) {
        return;
      } else if (item.is_deal != 0) {
        this.$notify({
          title: "提示",
          message: item.deal_warn,
        });
        return;
      }else if(item.available_qty<=0&&this.cardInfo.card_type==4){
        return;
      }

      let obj = {
        token: this.token,
        setmealId: item.setmeal_id,
        cardTypeId: this.card_type_id,
        card_type:this.card_type
      };

      this.$router.push(
        "/goodsAddress?obj=" + encodeURIComponent(JSON.stringify(obj))
      );
    },
    getCardInfo() {
      // 3.2.获取卡型信息
      let data = {
        cardTypeId: this.card_type_id,
        sysId: this.sysId,
        isLoadMaxQTY:1
      };

      cardInfoRequest(data).then((res) => {
        if (res) {
          let r = res.data[0];
          this.cardInfo = r;
          this.card_type = r.card_type;

          if (r.card_type == 1||r.card_type==4) {
            console.log(11)
          }else{
            this.$notify({
              title: "提示",
              message: "当前卡，非兑换卡",
            });
            setTimeout(() => {
              this.$router.push("/");
            }, 1000);
            return;
          }

          if(r.card_type==4){
            this.$notify({
              title:'提示',
              message:'当前卡还可兑换'+r.available_qty+'次'
            })
          }

          this.getTCList(); // 3.2.1.获取卡型信息成功后，获取卡型下套餐列表
          if (this.isdue != 1) {
            this.getGGList(); // 3.2.2.获取卡型信息成功后，判断是否为过期卡，非过期卡请求获取卡型下套餐公告列表
          }
        }
      });
    },

    getTCList() {
      // 3.3.获取卡型->套餐列表
      let data={}
      if(this.card_type==4){
        data = {
          cardTypeId: this.card_type_id,
          sysId: this.sysId,
          isLoadMaxQTY:1
          // pageNo: this.pageNo,
          // pageSize: this.pageSize,
        };
      }else{
        data = {
          cardTypeId: this.card_type_id,
          sysId: this.sysId,
          // pageNo: this.pageNo,
          // pageSize: this.pageSize,
        };
      }
      

      let afterUrl = "card/setmeallist";

      if (this.isdue == 1) {
        afterUrl = "card/expiresetmeallist";
      }

      cardInterTCRequest(afterUrl, data).then((res) => {
        if (res) {
          this.TCList = res.rows;
          // console.log("this.TCList")
          // console.log(this.TCList)
          this.totalPages = Math.ceil(res.total / this.pageSize);
        }
      });
    },

    getGGList() {
      // 3.4.获取卡型->套餐公告列表
      let data = {
        cardTypeId: this.card_type_id,
        sysId: this.sysId,
        pageNo: -1,
        pageSize: -1,
      };

      cardInterGGListRequest(data).then((res) => {
        if (res) {
          this.GGList = res.rows;
          // console.log("this.GGList")
          // console.log(this.GGList)
        }
      });
    },

    watchGGDetail(item) {
      // 3.5.查看公告详情
      let obj = {
        noticeId: item.notice_id,
        token: this.token,
      };

      this.$router.push(
        "/ggDetail?obj=" + encodeURIComponent(JSON.stringify(obj))
      );
    },
    getCardCustomizedInfo() {
      // 获取定制页信息
      let data = {
        cardCustomizedId: this.card_customized_id,
        sysId: this.sysId,
      };

      cardCustomizedInfoRequest(data).then((res) => {
        if (res) {
          let r = res.data[0];
          localStorage.web_order_success = r.web_order_success;
          localStorage.web_order_success_2 = r.web_order_success_2;
          localStorage.web_top_imgurl = r.web_top_imgurl;
          localStorage.web_top_linkurl = r.web_top_linkurl;
          localStorage.phone_top_imgurl = r.phone_top_imgurl;
          localStorage.phone_top_linkurl = r.phone_top_linkurl;
          localStorage.phone_convert_instructions =
            r.phone_convert_instructions;
          localStorage.web_rolling_notice = r.web_rolling_notice;
        }
      });
    },
    getCardCustomizedAdvertList() {
      // 获取定制页广告列表
      let data = {
        cardCustomizedId: this.card_customized_id,
        sysId: this.sysId,
        advertType: 0,
      };

      cardCustomizedAdvertListRequest(data).then((res) => {
        if (res) {
          this.showNoice = true;
          this.changeStatus;
          this.CCList = res.data;
        }
      });
    },
    clickedNoceItem(url) {
      if (url && url != "" && url != "#") {
        url =
          url.toLowerCase().indexOf("http:") > -1 ||
          url.toLowerCase().indexOf("https:") > -1
            ? url
            : "http://" + url;
        window.location = url;
      }
    },
    s_bshow(item) {
      // 3.6.筛选s型选手
      let res = "item borderShadow hands";

      if (item.is_deal == undefined) {
        res = "item item-o borderShadow hands";
      } else if (item.is_deal != 0) {
        res = "item item-o borderShadow hands";
      }else if(item.available_qty<=0&&this.cardInfo.card_type==4){
        res = "item item-o borderShadow hands";
      }
      return res;
    },

    downPage() {
      // 3.7.下一页
      clearTimeout(this.lineClickTimer);

      this.lineClickTimer = setTimeout(() => {
        if (this.pageNo >= this.totalPages) {
          this.$notify({
            title: "提示",
            message: "当前已经是最后一页",
          });
        } else {
          this.pageNo++;
          this.getTCList();
        }
      }, 300);
    },

    upPage() {
      // 3.8.上一页
      clearTimeout(this.lineClickTimer);

      this.lineClickTimer = setTimeout(() => {
        if (this.pageNo <= 1) {
          this.$notify({
            title: "提示",
            message: "当前已经是第一页",
          });
        } else {
          this.pageNo--;
          this.getTCList();
        }
      }, 300);
    },

    changePos() {
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      if (null != this.$refs.thediv) {
        this.Hoffset = this.$refs.thediv.offsetHeight; //获取元素高度
        this.Woffset = this.$refs.thediv.offsetWidth;
      }

      this.xPos = width - this.Woffset;
      this.yPos = height / 2 - this.Hoffset / 2;

      if (null != this.$refs.thediv) {
        // 滚动部分跟随屏幕滚动
        this.$refs.thediv.style.left =
          this.xPos +
          document.body.scrollLeft +
          document.documentElement.scrollLeft +
          "px";
        this.$refs.thediv.style.top =
          this.yPos +
          document.body.scrollTop +
          document.documentElement.scrollTop +
          "px";
      }

      // 滚动部分不随屏幕滚动
      //   this.$refs.thediv.style.left =
      //     this.xPos + document.body.scrollLeft + "px";
      //   this.$refs.thediv.style.top = this.yPos + document.body.scrollTop + "px";

      //   if (this.yon) {
      //     this.yPos = this.yPos + this.step;
      //   } else {
      //     this.yPos = this.yPos - this.step;
      //   }
      //   if (this.yPos < 0) {
      //     this.yon = 1;
      //     this.yPos = 0;
      //   }
      //   if (this.yPos >= height - this.Hoffset) {
      //     this.yon = 0;
      //     this.yPos = height - this.Hoffset;
      //   }

      //   if (this.xon) {
      //     this.xPos = this.xPos + this.step;
      //   } else {
      //     this.xPos = this.xPos - this.step;
      //   }
      //   if (this.xPos < 0) {
      //     this.xon = 1;
      //     this.xPos = 0;
      //   }
      //   if (this.xPos >= width - this.Woffset) {
      //     this.xon = 0;
      //     this.xPos = width - this.Woffset;
      //   }
    },
    clearFdAd() {
      clearInterval(interval);
    },
    starFdAd() {
      interval = setInterval(this.changePos, this.delay);
    },
    link(url) {
      if (url != "") {
        url =
          url.toLowerCase().indexOf("http:") > -1 ||
          url.toLowerCase().indexOf("https:") > -1
            ? url
            : "http://" + url;
        window.location = url;
      }
    },
  },

  mounted() {
    // 4.mounted
    this.sysId = localStorage.sysId || "";
    this.web_rolling_notice = localStorage.web_rolling_notice || ""; //滚动公告
    this.web_top_imgurl = localStorage.web_top_imgurl || "";
    this.web_top_linkurl = localStorage.web_top_linkurl || "";

    if (localStorage.web_tel) {
      this.web_tel = JSON.parse(localStorage.web_tel);
    } else {
      this.web_tel = "";
    }
    let res = JSON.parse(decodeURIComponent(this.$route.query.obj));
    this.token = res.token;
    this.card_type_id = res.card_type_id;
    this.isdue = res.isdue;
    this.card_customized_id = res.card_customized_id;
    if (this.card_customized_id) {
      this.getCardCustomizedInfo();
      this.getCardCustomizedAdvertList();
    } else {
      this.showNoice = false;
    }
    if (this.token || this.card_type_id || this.isdue) {
      this.getCardInfo();
    }

    interval = setInterval(this.changePos, this.delay);
  },
};
</script>


<style scoped lang="scss">
@import "./goodsList.scss";
body,
html {
  width: 100%;

  height: 100%;

  margin: 0;

  padding: 0;

  overflow: hidden;
}
.read {
  background-color: rgb(175, 37, 37);
  color: #fff;
  // margin-right: 43%;
  padding: 5px 10px;
}
.video li {
  list-style: none;
  float: left;
}
.listimg {
  // width: 50%;
  height: 250px;
  margin: 10px;
}
.righttip {
  margin-top: -15px;
  text-align: center;
}

</style>